export default __webpack_public_path__ + "static/media/wave.3e4fb6af.png";